import React from 'react';
import styled, { css } from 'styled-components';
import { Field } from 'formik';
import PropTypes from 'prop-types';
import Checkbox from './CheckBox';
import { FontWeight } from 'components/Text';
import ValidationError from './ValidationError';
import Label from './Label';
import { Button } from '../';
import { DialogComponent } from '../';
import { ButtonContainer } from '../';

const propTypes = {
    fieldName: PropTypes.string,
    options: PropTypes.array,
    onChange: PropTypes.func,
    label: PropTypes.string,
    row: PropTypes.bool,
};

const defaultProps = {
    fieldName: PropTypes.string,
    options: PropTypes.array,
    onChange: "",
    label: null
};

const StyledCheckbox = styled(Checkbox)`
    margin-bottom: 8px;
`;

const CheckboxContainer = styled.div`
    display: flex;
    margin-right: 10px;
    ${({ inline }) => inline && css`justify-content: flex-start;`}
`;

const Wrapper = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    ${({ inline }) =>
    inline 
    ? css`
    justify-content: flex-start;
    flex-wrap: wrap;
    align-items: flex-start;
    `
    : css`
    justify-content: flex-end;
    `
    }
`;

const ButtonContent = styled.div`
  display:flex;
  flex-direction: row;
  justify-content: center;
  gap: 20px;
  
  @media (max-width: 768px) {  
    flex-direction: column;
  }
`;

const CheckBoxFormSection = ({
    field,
    fieldName,
    options,
    onChange,
    label,
    disabled,
    readOnly,
    isRequired,
    hideLabelAsterisk,
    validationMinHeight,
    inline,
    validation,
    hasModal,
    modalDescription,
    form: { touched, errors, setFieldValue },
    rightIconComponent,
    ...props
}) => {
    const meta = {
        touched: touched[fieldName],
        error: errors[fieldName]
    };

    const [visibleModal, setVisibleModal] = React.useState(false);

    const optionYes = options.find(opt => opt && ['YES', 'SIM'].includes(opt.label.toUpperCase().trim()))?.value || '';
    const optionNo = options.find(opt => opt && ['NO', 'NÃO'].includes(opt.label.toUpperCase().trim()))?.value || '';

    const handleClick = () => {
        if (hasModal && modalDescription && (field.value?.idAnswerOption === optionNo?.idAnswerOption || !field?.value)) {
            setVisibleModal(true)
        } else if (!field?.value) {
            setFieldValue(field.name, optionYes)
            onChange(optionYes)
        } else if (field.value?.idAnswerOption === optionNo?.idAnswerOption) {
            setFieldValue(field.name, optionYes)
            onChange(optionYes)
        } else if (field.value?.idAnswerOption === optionYes?.idAnswerOption) {
            setFieldValue(field.name, optionNo)
            onChange(optionNo)
        }
    }

    return (
        <>
            {hasModal && modalDescription && visibleModal && (
                <DialogComponent width='80%' show={visibleModal} forceOnTop>
                    <div style={{ maxHeight: '80vh', overflowY: 'auto' }}>

                        <div dangerouslySetInnerHTML={{ __html: modalDescription }} />


                        <ButtonContent >
                            <Button
                                id="btnContinue"
                                type="button"
                                style={{ margin: '0px' }}
                                onClick={() => {
                                    setVisibleModal(false)
                                }}
                                third
                            >
                                FECHAR
                            </Button>
                            <Button
                                id="btnContinue"
                                type="button"
                                style={{ margin: '0px' }}
                                onClick={() => {
                                    setFieldValue(field.name, optionYes)
                                    setVisibleModal(false)
                                    onChange(optionYes)
                                }}
                                primary
                            >
                                ACEITAR
                            </Button>
                        </ButtonContent>
                    </div>
                </DialogComponent>
            )}
            <Wrapper
                disabled={disabled}
                inline={inline}
                {...props}
            >
                {props?.extraLabelTop && (
                    <Label
                        meta={meta}
                        width={!disabled  && !!rightIconComponent ? 60 : 100}
                        isRequired={isRequired}
                        weight={FontWeight.SemiBold}
                        inline={inline}
                        hideLabelAsterisk={hideLabelAsterisk}
                        style={props.extraLabelTop?.length < 4 ? {paddingLeft: '10px'} : {}}
                        onClick={(e) => {
                            e.preventDefault()
                            if (!disabled) {
                                handleClick()
                            }
                        }}
                    >
                        {props.extraLabelTop}
                    </Label>
                )}
                <CheckboxContainer inline={inline} {...props}>
                    <label >
                        <Field
                            disabled={disabled}
                            readOnly={readOnly}
                            name={fieldName}
                            value={field.value}
                            component={StyledCheckbox}
                            onClick={(e) => {
                                e.preventDefault()
                                handleClick()
                            }}
                            checked={field.value?.idAnswerOption === optionYes?.idAnswerOption}
                        />
                    </label>
                    {!disabled && !!rightIconComponent ? rightIconComponent : <></>}
                {label && (
                    <Label
                        meta={meta}
                        width={!disabled  && !!rightIconComponent ? 60 : 100}
                        isRequired={isRequired}
                        weight={FontWeight.SemiBold}
                        inline={inline}
                        hideLabelAsterisk={hideLabelAsterisk}
                        onClick={(e) => {
                            e.preventDefault()
                            if (!disabled) {
                                handleClick()
                            }
                        }}
                    >
                        {label}
                    </Label>
                )}
                </CheckboxContainer>
                <ValidationError
                    style={{ minWidth: '100%', display: 'flex' }}
                    meta={meta}
                    validationMinHeight={validationMinHeight}
                />
            </Wrapper >
        </>
    );
};

CheckBoxFormSection.propTypes = propTypes;
CheckBoxFormSection.defaultProps = defaultProps;

export default CheckBoxFormSection;
